export const BASE_URL = 'https://api.visitry.com:4000/api/';
